
import { sprintf } from "sprintf-js";

/**
 * Text.onAction callback for clamping pct values
 * between 0-100
 *
 * @param text_0
 * @param text_1
 */
const onPctAction = (text_0, text_1) => (component, text) => {
  let otherPrm = null;
  let currentPrm = null;
  let current = 0;
  if (text.name.id === text_0.name.id) {
    currentPrm = text_0;
    otherPrm = text_1;
    current = parseInt(text.getValue(component.state), 10);
  } else if (text.name.id === text_1.name.id) {
    currentPrm = text_1;
    otherPrm = text_0;
    current = parseInt(text.getValue(component.state), 10);
  }
  // Clamp 0 - 100
  current = Math.min(100, Math.max(0, Math.round(current)));
  const otherValue = 100 - current;
  const new_state = {
    ...otherPrm.copyState(component.state),
    ...currentPrm.copyState(component.state),
  };
  otherPrm.setValue(new_state, sprintf("%d", otherValue));
  currentPrm.setValue(new_state, sprintf("%d", current));
  component.setState(new_state);
};

export { onPctAction };
